module.exports = __webpack_public_path__ + "img/cluster-inactive.0b6277cb.svg";